import axios from 'axios'
import router from '@/router'
import { refreshHostInfo } from '@/api/main'

const addErrorLog = (errorInfo) => {
  Xinnet.message.warning(errorInfo.data?.msg);
}

const whitelist = [
  '/api/domain/checkTransferInDomains',
  '/download',
  '/zip',
]
export const reqs = {}
class HttpRequest {
  constructor(baseURL) {
    this.baseUrl = baseURL
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      // baseURL: process.env.VUE_APP_API,
      baseURL: '',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    }
    return config;
  }
  destroy(url) {
    delete this.queue[url]
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        config.onDownloadProgress = (event) => {
          if (typeof (config.onProgress || null) === 'function') {
            config.onProgress(event)
          }
        }
        if (config.useAbort) {
          const _url = processUrl(url)
          const prevRequest = reqs[_url]
          if (prevRequest) {
            prevRequest.controller?.abort()
          }
          const controller = new AbortController()
          config.signal = controller.signal
          reqs[_url] = { url: _url, controller }
        }
        this.queue[url] = true
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        this.destroy(url)
        if (whitelist.find(v => url.slice(0, v.length) === v)) {
          return res
        }
        if (res.status !== 200 || (res.data?.code !== '200' && !res.data?.status)) {
          if(url == '/api/login' && res.data.code == '403') {
          } else {
            Xinnet.message.error(res.data.msg)
            return Promise.reject('请求异常！')
          }
          
        }
        return res.data
      },
      (error) => {
        this.destroy(url)
        if (!error || error.name === 'CanceledError') {
          return Promise.reject('请求终止！')
        }
        const errorInfo = error.response
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config,
          } = JSON.parse(JSON.stringify(error))

          errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url },
          }
          if (!statusText) {
            errorInfo.statusText = error
          }
        } else {
          if (errorInfo.status === 996) {
            const route = window.location.hash.slice(1)
            if (route.includes('?r=')) {
              router.replace(route)
            } else {
              router.replace('/login?r=' + route)
            }
            setTimeout(() => {
              window.location.reload()
            }, 10)
            return
          }
          // 文件管理切换IP处理
          else if (errorInfo.status === 502 && errorInfo.config?.baseURL?.startsWith(process.env.VUE_APP_FILE_API)) {
            Xinnet.message.warning('网络波动请重试！')
            refreshHostInfo()
            return Promise.reject(error)
          }
        }
        addErrorLog(errorInfo)
        return Promise.reject(error)
      }
    )
  }
  request(options) {
    const instance = axios.create()
    instance.defaults.withCredentials = true
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}

const processUrlWhitelist = [
  '/api/host/getZones',
  '/api/host/getConfiguration',
]
function processUrl(url) {
  const res = processUrlWhitelist.find(v => url.startsWith(v))
  if (res) return res
  return url
}

export default HttpRequest
